import apiClient from "./apiClient";
import useApiWrapper from "./apiWrapper";

/** --------------------------
 *  Build Query Params
 *  ------------------------- */
const buildUrl = (baseUrl, filters = {}) => {
  const queryParams = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      // Handle boolean flag (dropdown → true)
      queryParams.append(
        key === "dropdown" ? "drop_down" : key,
        key === "dropdown" ? true : value
      );
    }
  });

  return queryParams.toString()
    ? `${baseUrl}?${queryParams.toString()}`
    : baseUrl;
};

/** --------------------------
 *  useApiMethods Hook
 *  ------------------------- */
const useApiMethods = () => {
  const { apiWrapper } = useApiWrapper();

  // Common request handler
  const request = (method, url, data = null, options = {}, setLoading) => {
    return apiWrapper(() =>
      apiClient.request({
        method,
        url,
        data,
        ...options,
      }),
      setLoading
    );
  };

  /** CRUD Methods */
  const fetch = (url, filters = {}, setLoading) => {
    const URL = buildUrl(`/${url}`, filters);
    return request("get", URL, null, {}, setLoading);
  };

  const create = (url, data, isFormData = false, setLoading) => {
    const headers = {
      "Content-Type": isFormData
        ? "multipart/form-data"
        : "application/json",
    };
    return request("post", url, data, { headers }, setLoading);
  };

  const update = (url, data, isFormData = false, setLoading) => {
    const headers = {
      "Content-Type": isFormData
        ? "multipart/form-data"
        : "application/json",
    };
    return request("put", url, data, { headers }, setLoading);
  };

  const remove = (url, data, setLoading) => {
    return request("delete", url, data, {}, setLoading);
  };

  return { fetch, create, update, remove };
};

export default useApiMethods;
